<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>
      თიბისი ლიზინგის CSR მიმართულება <br />
      <span style="font-family: TBCX-Regular;">Vol.2</span>
    </h1>
    <h6>დეკემბერი 2023</h6>
    <br />

    <img src="../../../../assets/blog/green-leasing/img1.jpg" alt="" />

    <p>
      წინა ბლოგში ხელოვნურ ინტელექტს ვთხოვეთ აღეწერა იდეალური სამუშაო კვირა კომპანიაში, რომელშიც თანამშრომლებზე ზრუნვაა
      პრიორიტეტული. ChatGPT-მ და ჩვენ გადავწყვიტეთ, რომ საუკეთესო ვარიანტი თიბისი ლიზინგში შემოხედვაა და არა, საერთოდ არ
      ვართ სუბიექტურები.
    </p>

    <p>
      როგორც უკვე აღვნიშნეთ, ჯანსაღი ცხოვრების წესის, ფიზიკური თუ გონებრივი აქტივობების პოპულარიზაციისთვის
      მრავალფეროვანი პროექტები განვახორციელეთ, თუმცა არანაკლებ მნიშვნელობას ვანიჭებთ თანამშრომლების ბედნიერებისა თუ
      კმაყოფილების კვლევებიდან ამოსულ უკუკავშირს, რომელზე დაყრდნობითაც სხვადასხვა აქტივობებს ვგეგმავთ,
    </p>

    <p>
      როგორც აღმოჩნდა, ჩვენი, როგორც ალბათ ნებისმიერი დაკავებული, საქმიანი, თანამედროვე ადამიანისთვის, ერთ-ერთი
      „ტკივილი“ სასარგებლო სამოქალაქო აქტივიზმისთვის არასაკმარისი დროა. ზუსტად ვიცით, რომ კარგი ადამიანები ვართ, ოღონდ
      არ ვიცით რა გზით შეიძლება ნებაყოფლობით ვემსახუროთ მათ, ვისაც ეს სჭირდება.
    </p>

    <img src="../../../../assets/blog/green-leasing/img2.jpg" alt="" />

    <p>
      BrandHR-ის დახურული კარი იმის ნიშანია, რომ განსაკუთრებული იდეები იხარშება, ოღონდ ჯერ პრივატულად, თანამშრომლების
      თვალსა და ყურს მიღმა. სწორედ ასეთი ერთ-ერთი შეხვედრისას გადაწყდა, რომ „პრო ბონო“ საქმიანობა უნდა დაგვეწყო, რაც
      გულისხმობს. სრულიად უსასყიდლო, ექსპერტულ, კომპეტენციის მიმართულებით დახმარებას მცირე ბიზნესისთვის, რომელსაც
      მსგავსი რესურსი არ აქვს. რადგან ეს თემა ვრცლად უკვე მიმოვიხილეთ, გიზიარებთ
      <a href="https://tbcleasing.ge/blog/blog-pro-bono" target="_blank">ბლოგს</a>, რომელსაც უნდა გაეცნო თუკი გამოგრჩა.
    </p>

    <img src="../../../../assets/blog/green-leasing/img3.jpg" alt="" />

    <p>
      აქვე, არ დაგვავიწყდეს, რომ კარგი მოქალაქეობა ეთიკურობის გარკვეულ ზღვარზეც გადის, მაგალითად - გარემოზე ზრუნვაზე.
      სწორედ ამიტომ, თითქმის 1 წელია, რაც მთელი თიბისი ლიზინგის მასშტაბით „ტენეს“ ყუთებში ვაგროვებთ პლასტმასას, ქაღალდს
      და ელემენტებს, რაც მუშავდება და პირველ ქართულ ეკომეგობრულ USB კაბელად გარდაიქმნება.
    </p>

    <p>
      მხოლოდ სეპარაცია არ კმარა, მნიშვნელოვანია ცნობიერების ამაღლებაც, რისთვისაც დახმარება „ტენეს“ დამფუძნებელს, სანდრო
      ლილუაშვილს ვთხოვეთ. ჩვენი მეგობარი სტარტაპის ხელმძღვანელმა სიამოვნებით ჩაგვიტარა ტრენინგი, რომლის მიხედვითაც
      მარტივი კითხვები ჩამოვაყალიბეთ. აღნიშნული კითხვები ყოველ კვირა თავსდება ჩვენს შიდა ჯგუფში, პირველი სწორი პასუხის
      ავტორი კი, აღიარებით და „ტენეს“ USB კაბელით ჯილდოვდება.
    </p>

    <img src="../../../../assets/blog/green-leasing/img4.jpg" alt="" />

    <p>
      SpaceRefinery-ის ოქროს რჩევების მიხედვით, საოფისე გარემოში პროდუქტიულობისა და კონცენტრაციის გაზრდისთვის საუკეთესო
      გზა - მცენარეების დამატებაა. კვლევის მიხედვით, თანამშრომლებში, რომელთა სამუშაო სივრცეშიც დიდი დოზით სიმწვანეა,
      15%-ით უკეთ გრძნობენ თავს, ვიდრე ისინი, რომელთა ორგანიზაციებშიც აღნიშნულ საკითხს არ აქცევენ ყურადღებას. მეტიც,
      სიდნეის უნივერსიტეტის მოწოდებული ციფრები შემდეგზე მეტყველებს, მცენარეები ოფისში ამცირებს სტრესს, შფოთვას, ნეგატიურ
      ემოციებს. მნიშვნელოვანია, რომ აღნიშნული ფაქტორი არა მხოლოდ მენტალურ, არამედ ფიზიკურ ჯანმრთელობაზეც მოქმედებს,
      რადგან გამწვანებულ სივრცეში მეტია ჟანგბადი და ტენიანობა.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green">
      <div class="container">
        <p class="bold-text">
          ჩვენს თანამშრომლებს აქვთ არაჩვეულებრივი შესაძლებლობა, ყოველდღიურად შესვენება თბილისის ყველაზე მწვანე
          ტერიტორიაზე ვაკის პარკში გაატარონ, ამავდროულად, იმუშაონ საოფისე სივრცეში, რომლის ყველა სართულზე, ყველა
          კუთხეში, ფაქტობრივად ყოველ 1 მეტრში სხვადასხვა ტიპის მცენარეა განთავსებული.
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      Vol.2-ს აქ დავასრულებთ, თუმცა ბლოგების სერია აუცილებლად გაგრძელდება კიდევ მეტი საინტერესო ფაქტით ჩვენს შესახებ.
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      CSR Direction in TBC Leasing<br />
      <span style="font-family: TBCX-Regular;">Vol.2</span>
    </h1>
    <h6>December 2023</h6>
    <br />

    <img src="../../../../assets/blog/green-leasing/img1.jpg" alt="" />

    <p>
      In the previous blog, we asked artificial intelligence to describe the ideal workweek in a company where employee
      well-being is a priority. ChatGPT and we decided that the best option is to look at TBC Leasing and, no, we are
      not subjective at all.
    </p>

    <p>
      As we have already mentioned, we have implemented various projects to promote a healthy lifestyle, physical and
      mental activities, but we also place great importance on the feedback received from employee happiness or
      satisfaction surveys, which we use as the basis for planning various activities.
    </p>

    <p>
      As it turned out, one of the "pains" for us, as for any busy, business-oriented modern person, is the lack of time
      for meaningful civic activism. We know for sure that we are good people, but we are not sure how to voluntarily
      serve those in need.
    </p>

    <img src="../../../../assets/blog/green-leasing/img2.jpg" alt="" />

    <p>
      The closed door of BrandHR is a sign that special ideas are being developed, but first privately, behind the eyes
      and ears of employees. It was during one such meeting that it was decided to start "pro bono" activities, which
      involve providing completely free, expert, competency-based assistance to small businesses that do not have such
      resources. Since we have already discussed this topic in detail, I am sharing the
      <a href="https://tbcleasing.ge/blog/blog-pro-bono" target="_blank">blog</a> with you, which you should read if you
      missed it.
    </p>

    <img src="../../../../assets/blog/green-leasing/img3.jpg" alt="" />

    <p>
      Here, let us not forget that good citizenship also extends to a certain boundary of ethics, such as caring for the
      environment. That is why, for almost a year now, throughout the entire TBC Leasing, we have been collecting
      plastic, paper, and batteries in "Tenes" boxes, which are processed and transformed into the first Georgian
      eco-friendly USB cables.
    </p>

    <p>
      Separation alone is not enough; raising awareness is also crucial, for which we asked for help from the founder of
      "Tenes," Sandro Lilushvili. Our friend, the startup leader, kindly conducted a training session for us, based on
      which we formulated simple questions. These questions are posted every week in our internal group, and the first
      person to give the correct answer is rewarded with recognition and a "Tenes" USB cable.
    </p>

    <img src="../../../../assets/blog/green-leasing/img4.jpg" alt="" />

    <p>
      According to the golden tips from SpaceRefinery, the best way to increase productivity and concentration in the
      office environment is by adding plants. Research shows that employees working in spaces with a high amount of
      greenery feel 15% better than those in organizations that do not pay attention to this issue. Moreover, the
      figures provided by the University of Sydney suggest that plants in the office reduce stress, anxiety, and
      negative emotions. It is important to note that this factor impacts not only mental but also physical health, as
      green spaces have higher oxygen levels and humidity.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-green">
      <div class="container">
        <p class="bold-text">
          Our employees have the wonderful opportunity to spend their daily break in Tbilisi’s greenest area, Vake Park,
          while simultaneously working in an office space where, on every floor, in every corner, practically every
          meter has different types of plants placed.
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      We will end Vol.2 here, but the series of blogs will certainly continue with even more interesting facts about us.
    </p>
  </div>
</ng-container>
